// /contexts/languageContext.ts
import { createContext } from "react";
import { LanguageContextType } from "../types/languageTypes";

// Context의 초기값을 undefined로 설정합니다
const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export default LanguageContext;
